export default __webpack_public_path__ + "static/media/Power washing.0c1fa537.jpg";